import * as _ from 'lodash'
import moment from 'moment'
import jstz from 'jstz';
import { PaymentCardT } from '../types/Payments';

export const stringLitArray = <L extends string>(arr: L[]) => arr;


/**
 * 
 * @param date 
 * @param format 
 * @returns 
 */
export const formatDateToUtc = (date): Date | string => {
  if (date == "" || !moment(date).isValid()) {
    return "";
  }
  try {
    return moment(moment(date).utc().toDate()).format()
  } catch (error) {
    return '';
  }
}

/**
 * formatDate
 * @param date
 * @param format
 * @return ''|string
 */
export const formatDate = (date, format = "MM/DD/YYYY h:mm:ss A", toLocal = false) => {
  // console.log("moment(date)->date", date)
  if (date == "" || !moment(date).isValid()) {
    return "";
  }
  try {
    if (toLocal) {
      // console.log("moment(date)", moment(date))
      date = moment(date).toDate()
      return moment.utc(date).local().format(format)
    }
    return moment(date).format(format)
  } catch (error) {
    return '';
  }
}

/**
 *
 * @param date
 * @returns
 */
export const dateToUtc = (date) => {
  if (date == "" || !moment(date).isValid()) {
    return "";
  }
  return moment.utc(date)
}

/**
 *
 * @param value
 * @returns boolean
 */
export const isNumeric = (value): boolean => {
  return /^-?\d+$/.test(value);
}

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}




export const regexFindMatches = (regex, str, matches = []) => {
  const res = regex.exec(str)
  res && matches.push(res) && regexFindMatches(regex, str, matches)
  return matches
}
/**
 *
 * @param value
 * @returns
 */
export const removePrefixUS = (value: string) => {
  try {

    const regex = /^\+[1]/gm;
    const result = value.replace(regex, '');
    return result

  } catch (error) {
    return ""
  }
}


/**
 * validatePhoneForE164
 * @param phoneNumber
 * @returns
 */
const validatePhoneForE164 = (phoneNumber): boolean => {
  const regEx = /^\+[1-9]\d{10,14}$/;

  return regEx.test(phoneNumber);
};

// validatePhoneForE164('+12125551212'); // true
// validatePhoneForE164('12125551212'); // false
// validatePhoneForE164('2125551212'); // false
// validatePhoneForE164('+1-212-555-1212'); // false
// validatePhoneForE164('+1 212 555 1212'); // false
// validatePhoneForE164('+1 (212) 555-1212'); // false


export const timeout = async (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}



/**
 *
 * @param dateOne
 * @param dateTwo
 * @returns
 */
export const isEqualDates = (dateOne: string, dateTwo: string): boolean => {
  return moment(dateOne).isValid() && moment(dateTwo).isValid() && moment(dateOne).format("MM/DD/YYYY") == moment(dateTwo).format("MM/DD/YYYY")
}


/**
 *
 * @param str
 * @returns
 */
export const stringToSlug = (str) => {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to = "aaaaeeeeiiiioooouuuunc------";

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
}



export const generatePassword = (length = 8) => {

  let charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
  let retVal = ""
  for (var i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

/**
 *
 * @param value
 */
export const parseFloatTotal = (value: number | string, nDecimalDigits = 2): string => {
  if (!value) {
    return "0.00";
  }
  return parseFloat(`${value}`).toFixed(nDecimalDigits)
}

export const getTimezoneName = () => {
  const timezone = jstz.determine();


  return timezone.name()
}
export const getTimeZone = () => {
  // var now = new Date().toString();
  // var timeZone = now.replace(/.*[(](.*)[)].*/,'$1');//extracts the content between parenthesis
  let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  // let timeZone = momentTimezone.tz.guess()
  // console.log("offsetInHours", momentTimezone.tz.guess())
  return timeZone;
}
/**
 *
 * @returns
 */
export const getTimezoneOffset = () => {
  const dateTimeUtc = moment.utc()
  let local = moment(dateTimeUtc).local()
  // console.log("getTimezoneName", getTimezoneName())
  return local.utcOffset();
}



export const getInitialsLastName = (firstName: string, lastName: string): string => {
  let name = ""
  if (firstName != "" && _.isString(firstName)) {
    name = `${firstName} `
  }

  if (lastName != "" && _.isString(lastName)) {
    lastName = lastName.length > 1 ? lastName[0] : lastName
    name = `${name}${lastName}`
  }

  return _.startCase(name)
}


export const sanitizeNumeric = (value: string | number): number | null => {

  const regex = /[^0-9\.]/g

  if (isNumeric(value)) {
    return value as number
  }
  let val = _.isString(value) ? value.replace(regex, '') : ""

  let result = Number(parseFloat(val).toFixed(2))
  if (!isNumeric(result)) {
    return null
  }
  return result
}

/**
 *
 * @param val
 * @returns
 */
export const validateLengthNumberPhone = (val): boolean => {
  let valid = false

  try {
    const _val = val.toString()
    if ((_val.length >= 10 && _val.length < 14) == true) {
      valid = true;
    }

  } catch (error) {
    valid = false;
  }
  return valid
}

/**
 *
 * @param value
 * @returns
 */
export const numberPhoneIsValid = (value: string | number): boolean => {
  return validateLengthNumberPhone(sanitizeNumeric(value))
}






/**
 * get primaryCard from cards
 * @param cards
 * @returns
 */
export const findPrimaryCard = (cards: Array<PaymentCardT>): PaymentCardT | null => {
  if (!_.isArray(cards)) {
    return null
  }

  let varPrimaryCard = cards.find((x) => _.has(x, "primaryCard") && !_.isNil(x.primaryCard) && x.primaryCard > 0)
  if (varPrimaryCard) {
    return cards.find((x) => x.id == varPrimaryCard.primaryCard)
  }
  return null
}



export const naviagte = (history, path: string): void => {

  history.push({
    pathname: `${path}`
  })
}



export const getQueryStringParams = (query: string): any => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
      .split('&')
      .reduce((params, param) => {
        let [key, value] = param.split('=');
        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
        return params;
      }, {}
      )
    : {}
};

/**
 *
 * @param match
 */
export const getBaseUrl = (match) => {
  let url = match?.url
  return url.replace(/\/[0-9]+$/g, '');
}

/**
 * Converts number into currency format
 * @param {number} number    Number that should be converted.
 * @param {string} [decimalSeparator]    Decimal separator, defaults to '.'.
 * @param {string} [thousandsSeparator]    Thousands separator, defaults to ','.
 * @param {int} [nDecimalDigits]    Number of decimal digits, defaults to `2`.
 * @return {string} Formatted string (e.g. numberToCurrency(12345.67) returns '12,345.67')
 */
export const numberToCurrency = (number, decimalSeparator = ".", thousandsSeparator = ",", nDecimalDigits = 2) => {
  //default values
  decimalSeparator = decimalSeparator || '.';
  thousandsSeparator = thousandsSeparator || ',';
  nDecimalDigits = nDecimalDigits == null ? 2 : nDecimalDigits;
 
  var fixed = parseFloatTotal(number, nDecimalDigits), //limit/add decimal digits
    parts = new RegExp('^(-?\\d{1,3})((?:\\d{3})+)(\\.(\\d{' + nDecimalDigits + '}))?$').exec(fixed); //separate begin [$1], middle [$2] and decimal digits [$4]

  if (parts) { //number >= 1000 || number <= -1000
    return parts[1] + parts[2].replace(/\d{3}/g, thousandsSeparator + '$&') + (parts[4] ? decimalSeparator + parts[4] : '');
  } else {
    return fixed.replace('.', decimalSeparator);
  }
}